import { render, staticRenderFns } from "./ExpenditureCategoryStatistic.vue?vue&type=template&id=40f4b0ea&scoped=true&"
import script from "./ExpenditureCategoryStatistic.vue?vue&type=script&lang=js&"
export * from "./ExpenditureCategoryStatistic.vue?vue&type=script&lang=js&"
import style0 from "./ExpenditureCategoryStatistic.vue?vue&type=style&index=0&id=40f4b0ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f4b0ea",
  null
  
)

export default component.exports